module.exports = __webpack_public_path__ + "media/images/icon-2-1b166623db04fa824d9929be6b855c3f.png";